import React, { ReactElement, useEffect } from 'react'
import {
	CopyrightAgentLoader,
	PrimaryButton,
	Row,
	SearchInput,
	TextLabel,
	Typography,
} from '@copyrightagent/basic-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import globalUseStyle from '../style'
import { UploadTransferAgreementModal } from './UploadTransferAgreementModal'
import clsx from 'clsx'
import { useTransferAgreementsStore } from '../stores/transferAgreementStore'
import { RouteComponentProps } from 'react-router'
import { useTransferAgreementImagesStore } from '../stores/transferAgreementImagesStore'
import Response from 'lib/http/Response'

const TransferAgreementsList = (props: RouteComponentProps): ReactElement => {
	const {
		hasTransferAgreementsInitiallyLoaded,
		fetchTransferAgreements,
		transferAgreements,
		totalTransferAgreementsCount,
		setSearchString,
		searchString,
		setTransferAgreementModalOpen,
	} = useTransferAgreementsStore()
	const { selectedTransferAgreement } = useTransferAgreementImagesStore()
	const globalClasses = globalUseStyle()

	useEffect(() => {
		fetchTransferAgreements({
			isInitialLoad: true,
		})
	}, [])

	const handleSearch = async () => {
		fetchTransferAgreements({
			isInitialLoad: true,
		})
	}

	const selectTransferAgreement = (transferAgreementId: string) => {
		props.history.push(`/transfer-agreements/${transferAgreementId}`)
	}

	return (
		<div className={globalClasses.subPageContainer}>
			<div className={globalClasses.titleContainer}>
				<div>
					<Typography variant="body2" className={globalClasses.listTitle}>
						Transfer of Rights Agreement
					</Typography>
					<Typography variant="body2" fontColor="rgb(142, 147, 155)">
						{totalTransferAgreementsCount} agreements
					</Typography>
				</div>
				<PrimaryButton
					text={'Upload Agreement'}
					onClick={() => setTransferAgreementModalOpen(true)}
				/>
			</div>
			<div className={globalClasses.searchContainer}>
				<SearchInput
					value={searchString}
					onChange={(e) => setSearchString(e.target.value)}
					placeholder={'Search for Transfer Agreement by photographer name'}
				/>
				<PrimaryButton
					style={{ marginLeft: '16px' }}
					text={'Search'}
					onClick={handleSearch}
				/>
			</div>
			<div
				id="transferAgreementsList"
				className={globalClasses.listContainer}
				style={{ height: 'calc(100vh - 292px)' }}
			>
				{hasTransferAgreementsInitiallyLoaded ? (
					transferAgreements.length > 0 ? (
						<InfiniteScroll
							className={globalClasses.infiniteScrollWrap}
							dataLength={transferAgreements.length}
							next={fetchTransferAgreements}
							hasMore={transferAgreements.length < totalTransferAgreementsCount}
							loader={
								<div key={0} className={globalClasses.loadingContainer}>
									<CopyrightAgentLoader />
								</div>
							}
							scrollableTarget="transferAgreementsList"
						>
							{transferAgreements.map((transferAgreement, index) => (
								<Row justify="flex-start" key={index}>
									<div
										className={clsx(
											globalClasses.card,
											selectedTransferAgreement?.transfer_agreement_id ===
												transferAgreement.transfer_agreement_id &&
												globalClasses.selectedCard,
										)}
										onClick={() =>
											selectTransferAgreement(transferAgreement.transfer_agreement_id)
										}
										style={{ display: 'flex' }}
									>
										<div
											className={globalClasses.containerWithChip}
											style={{ width: '220px' }}
										>
											<div>
												<Typography
													variant="body2"
													fontColor="rgb(142, 147, 155)"
												>
													Photographer Name
												</Typography>
												<Typography variant="body2">
													{transferAgreement.photographer_name}
												</Typography>
											</div>
										</div>
										<div className={globalClasses.rowDivider} />
										<div className={globalClasses.containerWithChip}>
											<div>
												<Typography variant="body2">
													{transferAgreement.transfer_agreement_image_count}{' '}
													images
												</Typography>
											</div>
											{transferAgreement.transfer_agreement_image_count ===
												0 && (
												<TextLabel
													uppercase
													size="small"
													labelText={'Missing images'}
													color={'yellow'}
												/>
											)}
										</div>
									</div>
								</Row>
							))}
						</InfiniteScroll>
					) : (
						<div className={globalClasses.loadingContainer}>
							<Typography variant="body2" fontColor="rgb(142, 147, 155)">
								No agreements found.
							</Typography>
						</div>
					)
				) : (
					<div className={globalClasses.loadingContainer}>
						<CopyrightAgentLoader />
					</div>
				)}
			</div>
			<UploadTransferAgreementModal
				uploadSuccessCallback={(response: Response) => {
					props.history.push(
						`/transfer-agreements/${response.data.transfer_agreement_id}`,
					)
				}}
			/>
		</div>
	)
}

export default TransferAgreementsList
